import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SmetaPostItem from './SmetaPostItem'
import SmetaSubTotalItem from './SmetaSubTotalItem'
import { fetchPosts } from "../../actions/postActions"
import { fetchOrders } from '../../actions/orderActions'
import isEmpty from 'lodash/isEmpty'
import { fnum } from '../../utils/utils'
import moment from 'moment'
import axios from 'axios'
import { servAddr } from '../../servAddr'

class SmetaForm extends React.Component {

  state = {errors: {}}

  orderId = this.context.router.location.query.order_id;

  componentWillMount(){
    this.props.fetchPosts(this.orderId);
    this.props.fetchOrders();
    const orders = this.props.orders;
    if(orders.length){
      this.order = orders.find(el => {return el.order_id === parseInt(this.orderId,10)});
      if(this.order){
        this.setState({order: this.order});
      }
    }
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps){
    if(this.props!==nextProps){
      const orders = nextProps.orders;
      if(orders.length){
        this.order = orders.find(el => {return el.order_id === parseInt(this.orderId,10)});
        if(this.order){
          this.setState({order: this.order});
        }
      }
    }
  }

  backToOrder = e => {
    e.preventDefault();
    this.context.router.goBack();
  }

  exportClick = () => {
    this.setState({errors: {}});
    const { order_id, order_comp_id } = this.state.order;
    const { comps } = this.props;
    axios({
      method: 'get',
      url: servAddr + 'excel_smeta?order_id=' + order_id,
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `Смета ${comps[order_comp_id].comp_desc} ${moment().format('Y-MM-DD')}.xls`;
      link.click();
    }, (err) => {
      this.setState({
        errors: err.response.data.errors || {form: "Ошибка " + err.response.status}
      });
    });
  }

  render() {
    if(isEmpty(this.props.comps)
      || isEmpty(this.props.orders)
      || isEmpty(this.props.places)
      || isEmpty(this.props.srvgs)
      || isEmpty(this.props.posts)
      || isEmpty(this.props.srvcs)
    ){
      return(<div>Не загружены данные</div>);
    }
    if(this.props.comprights.indexOf(this.order.order_comp1_id) === -1){
      return(<div>Нет доступа</div>);
    }
    if(!this.state.order){
      return (
        <div>Заказ не найден</div>
      );
    }
    const { places, comps, srvcs, srvgs } = this.props;
    const { errors, order } = this.state;
    const data = this.props.posts[this.order.order_id];

    const activeData = data.filter(el => {
      if(
        el.post_active === 1 &&
        el.post_payer === order.order_comp_id &&
        srvcs[el.post_srvc_id].srvc_type === 1
       ){
        return true;
      }
      return false;
    });

    const sortD = activeData.sort( (a, b) => {
      if(a.post_sort < b.post_sort)
        return -1
      if(a.post_sort > b.post_sort)
        return 1
      if(a.post_desc < b.post_desc)
        return -1
      if(a.post_desc > b.post_desc)
        return 1
      if(a.post_id < b.post_id)
        return -1
      if(a.post_id > b.post_id)
        return 1
      return 0
    });

    const fltrD = sortD;

    var postG = {};
    var postSum = 0;
    var subT = {post_price:0,post_qntt:0};
    var taxPost = {post_price:0,post_qntt:0};
    for (var i=0; i < fltrD.length; i++){
      if(srvgs[fltrD[i].post_srvg_id].srvg_subtotal === 1){
        subT = fltrD[i];
      }
      else if(srvgs[fltrD[i].post_srvg_id].srvg_subtotal === 2){
        taxPost = fltrD[i];
      }
      else{
        if (!postG.hasOwnProperty(fltrD[i].post_srvg_id)){
          postG[fltrD[i].post_srvg_id] = {priceSum:0,costSum:0,arr:[]};
        }
        postG[fltrD[i].post_srvg_id].arr.push(fltrD[i]);
        postG[fltrD[i].post_srvg_id].priceSum += fltrD[i].post_price*fltrD[i].post_qntt;
        postG[fltrD[i].post_srvg_id].costSum += fltrD[i].cost_price*fltrD[i].cost_qntt;
        postSum += fltrD[i].post_price * fltrD[i].post_qntt;
      }
    }
    const comission = subT.post_price * subT.post_qntt;
    const tax = taxPost.post_price * taxPost.post_qntt;

    var mappedData = [];
    var groupCount = 1;
    const srvgsArr = [];
    for (let key in srvgs){
      if(srvgs.hasOwnProperty(key)) {
        srvgsArr.push(srvgs[key]);
      }
    }
    srvgsArr.sort((a, b) => {
      if(a.srvg_sort < b.srvg_sort)
          return -1
      if(a.srvg_sort > b.srvg_sort)
          return 1
      if(a.srvg_desc < b.srvg_desc)
          return -1
      if(a.srvg_desc > b.srvg_desc)
          return 1
      return 0
    });

    for (let srvgIdx = 0; srvgIdx < srvgsArr.length; srvgIdx++){
      let key = ""+srvgsArr[srvgIdx].srvg_id;
      if(postG.hasOwnProperty(key)){
        mappedData.push(
          <tr className="warning" key={key+".1"}>
            <td>{groupCount}</td>
            <td>{srvgs[key].srvg_desc}</td>
            <td></td><td></td><td></td>
          </tr>
        );
        for(var j=0; j < postG[key].arr.length; j++){
          mappedData.push(
            <SmetaPostItem
              key={postG[key].arr[j].post_id}
              num={""+groupCount+"."+(j+1)}
              data={postG[key].arr[j]}
              updtBlnc={this.props.updtBlnc}
            />
          );
        }
        mappedData.push(
          <tr key={key+".2"}>
            <th colSpan="2">Итого по группе</th>
            <th></th><th></th>
            <th className="text-right">{fnum(postG[key].priceSum)}</th>
          </tr>
        );
        groupCount++;
      }
    }

    const subTotal = subT.hasOwnProperty('post_desc') > 0 ?
      <tr className="info">
        <th colSpan="2">Подитог</th>
        <th></th><th></th>
        <th className="text-right">{fnum(postSum)}</th>
      </tr>
      : [];
    const afterSub =
      <SmetaSubTotalItem
        srvcs={srvcs}
        srvgs={srvgs}
        data={subT}
        order={order}
        updtBlnc={this.props.updtBlnc}
      />;

    const beforeTax = taxPost.hasOwnProperty('post_desc') > 0 ?
      <tr className="success">
        <th colSpan="2">Итог без налогов</th>
        <th></th><th></th>
        <th className="text-right">{fnum(postSum+comission)}</th>
      </tr>
      : [];
    const taxLine =
      <SmetaSubTotalItem
        srvcs={srvcs}
        srvgs={srvgs}
        data={taxPost}
        order={order}
        updtBlnc={this.props.updtBlnc}
      />;

    return (
      <div>
        <div className="form-group hidden-print">
          <button className="btn btn-default"
            onClick={this.backToOrder}>
            Назад
          </button>{" "}
          <button className="btn btn-default"
            onClick={this.exportClick}>
            Экспорт в Excel
          </button>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </div>
        <div className="toPrint">
          <table className="table borderless">
            <tbody>
              <tr>
                <td rowSpan="4">
                  <img alt="Artel logo" src="/img/logo.png" />
                </td>
                <td>Компания</td>
                <td><b>{comps[order.order_comp_id].comp_long}</b></td>
              </tr>
              <tr>
                <td>Мероприятие</td>
                <td><b>{order.order_desc}</b></td>
              </tr>
              <tr>
                <td>Дата проведения</td>
                <td><b>{moment(order.order_edate).format('L')}</b></td>
              </tr>
              <tr>
                <td>Место</td>
                <td><b>{places[order.order_place_id].place_desc}</b></td>
              </tr>
            </tbody>
          </table>
          <h3 className="text-center">Смета от {moment().format('L')}</h3>
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>№</th>
                <th className="col-xs-9">Наименование</th>
                <th className="col-xs-1 text-right">Цена,<br />руб.</th>
                <th className="col-xs-1 text-right">Кол<br />во</th>
                <th className="col-xs-1 text-right">Итого,<br />руб.</th>
              </tr>
            </thead>
            <tbody>
              {mappedData}
              {subTotal}
              {afterSub}
              {beforeTax}
              {taxLine}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan="2">Итог</th>
                <th></th><th></th>
                <th className="text-right">
                  {fnum(postSum+comission+tax)}
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    )

  }
}

SmetaForm.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapPostsToProps(store) {
  return {
    orders: store.orders.data,
    comprights: store.auth.comprights,
    posts: store.posts,
    comps: store.comps.data,
    places: store.places.data,
    srvcs: store.srvcs.data,
    srvgs: store.srvgs.data
  }
}

export default connect(mapPostsToProps, { fetchPosts, fetchOrders })(SmetaForm);



// WEBPACK FOOTER //
// ./src/components/smeta/SmetaForm.js